import {firebaseDb} from '../../firebase';

export const GET_PROJECT_LOCATIONS_REQUEST = 'GET_PROJECT_LOCATIONS_REQUEST';
export const GET_PROJECT_LOCATIONS_SUCCESS = 'GET_PROJECT_LOCATIONS_SUCCESS';
export const GET_PROJECT_LOCATIONS_FAILURE = 'GET_PROJECT_LOCATIONS_FAILURE';

export const getProjectLocations = (projectId) => dispatch => {
    dispatch({type: GET_PROJECT_LOCATIONS_REQUEST });
    try {
        firebaseDb.ref(`project-location/${projectId}`).on('value', (snapshot) => {
            dispatch({type: GET_PROJECT_LOCATIONS_SUCCESS, payload: { location:snapshot.val(), projectId }});
        });
    } catch (error) {
        dispatch({type: GET_PROJECT_LOCATIONS_FAILURE, payload: error});
    }
};
